module.exports = __webpack_public_path__ + "d57a6d07e378fd66.svg";